import "./AboutMe.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import Features from "./sections/Features";
import ClientTestimonials from "./sections/ClientTestimonials";
import Footer from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <Header />
      <Introduction />
      <Features />
      <ClientTestimonials />
      <Footer />
    </div>;
}